import { render, staticRenderFns } from "./addRemoveTrackedItem.vue?vue&type=template&id=1432d20f"
import script from "./addRemoveTrackedItem.js?vue&type=script&lang=js&external"
export * from "./addRemoveTrackedItem.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports